import Vue from 'vue'
import VueSignaturePad from 'vue-signature-pad'

// v2 Vue 2 sürümüdür; v3 Vue 3 peer'ı ister ve sessizce mount olmaz.
Vue.use(VueSignaturePad)
